import {
  Button,
  ButtonGroup,
  closeCurrentDialog,
  DataStatus,
  showNotification,
} from 'platform/components';
import {Text, VStack} from 'platform/foundation';

import {isNil} from 'ramda';

import {useBlockUserMutation, useDeactivateUserMutation, useGetUserQuery} from '@dms/api/customer';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

type DeactivateBranchDialogContentProps = {
  userId: string;
  onSuccess?: () => void;
};

export function DeactivateUserDialogContent(props: DeactivateBranchDialogContentProps) {
  const [deactivateUser, {isLoading: isDeactivateUserMutationLoading}] =
    useDeactivateUserMutation();
  const [blockUser, {isLoading: isBlockUserMutationLoading}] = useBlockUserMutation();
  const {data: userData, isLoading: isUserQueryLoading} = useGetUserQuery({id: props.userId});

  const areMutationsLoading = isDeactivateUserMutationLoading || isBlockUserMutationLoading;

  const handleDeactivateUser = async () => {
    if (isNil(userData)) {
      return;
    }
    if (userData.blocked === false) {
      // if user isn't blocked yet, we need to call block mutation, and only THEN deactivation
      await blockUser({userId: props.userId}).unwrap().catch(handleApiError);
    }
    deactivateUser({userId: props.userId})
      .unwrap()
      .then(() => {
        showNotification.success(i18n.t('general.notifications.success'));
        closeCurrentDialog();
        props.onSuccess?.();
      })
      .catch(handleApiError);
  };

  const userName = [userData?.firstName, userData?.lastName].filter(Boolean).join(' ');

  return (
    <DataStatus isLoading={isUserQueryLoading}>
      <VStack spacing={1}>
        <Text>{i18n.t('entity.deactivateUserDialog.description', {name: userName})}</Text>
      </VStack>
      <ButtonGroup align="right">
        <Button
          data-testid="deleteBranchDialogConfirm"
          variant="primary"
          onClick={handleDeactivateUser}
          isLoading={areMutationsLoading}
          title={i18n.t('general.actions.confirm')}
        />
      </ButtonGroup>
    </DataStatus>
  );
}
